import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

export const TrimaRankingQuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${prem(8)} ${prem(16)} ${prem(20)};
  gap: ${prem(16)};

  .trima-question-label {
    font-size: ${prem(18)};
    font-weight: 600;
    line-height: 1.35;
    color: var(--ion-text-color);
    margin: ${prem(4)} 0 0;
  }

  .trima-instruction {
    font-size: ${prem(13)};
    color: var(--ion-text-color-secondary);
    font-style: italic;
    margin: 0;
  }

  .trima-rank-marker {
    display: flex;
    align-items: center;
    gap: ${prem(8)};
    font-size: ${prem(12)};
    color: var(--ion-text-color-secondary);
    font-weight: 500;
  }

  .trima-rank-marker.top {
    margin-bottom: ${prem(-4)};
  }

  .trima-rank-marker.bottom {
    margin-top: ${prem(-4)};
  }

  .trima-cards-list {
    display: flex;
    flex-direction: column;
    gap: ${prem(8)};
  }

  .trima-validate-row {
    display: block;
    margin-top: ${prem(12)};
    width: 100%;
    align-self: center;
  }
`;
